{
    "DAYS": "giorni",
    "HOURS": "ore",
    "MINUTES": "minuti",
    "SECONDS": "secondi",
    "STARTING_SOON": "Inizia presto...",
    "DEFAULT_ERROR": "Errore di riproduzione",
    "DEFAULT_ERROR_DESCRIPTION": "Impossibile riprodurre il video. Per favore riprova più tardi.",
    "API_ERROR": "Errore nel recupero delle informazioni video",
    "API_ERROR_DESCRIPTION": "Errore nel recupero dei dettagli del video. Controlla il tuo videoId e la connessione internet e riprova.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorizzazione",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "Non hai il permesso di riprodurre questo video.",
    "ERROR_CODE_GEO_BLOCKED": "Restrizione geoblocking",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Spiacenti, questo video non è disponibile nella tua regione a causa di restrizioni geografiche.",
    "ERROR_CODE_NOT_ENTITLED": "Non autorizzato",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Spiacenti, non sei autorizzato a riprodurre questo video.",
    "ERROR_CODE_VPN_BLOCKED": "VPN BLOCCATA",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Questo video non è disponibile a causa dell'uso di una VPN.",
    "ERROR_CODE_IP_CHANGED": "Cambio di rete",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "Sei passato inaspettatamente a un'altra rete. Per favore riprova.",
    "ERROR_CODE_VPN_DETECTED": "VPN rilevata",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "Abbiamo rilevato una VPN. Disattivala e riprova.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Proxy anonimo rilevato",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "Abbiamo rilevato un proxy anonimo o un server. Disattivalo e riprova."
}
